import { Check, Minus } from "lucide-react";

// E-SPR ("Ada"/"Tidak Ada") and E-KMKB ("Sudah"/"Belum"; records from before the field existed have none = "Belum").
// Solid white badges with dark text so they stay readable on every row tint (JK blue/pink, Antrian's over-threshold
// yellow); the text carries the state, the icon and border colour only reinforce it.
const DONE = "bg-white text-emerald-800 border-emerald-300";
const PENDING = "bg-white text-amber-800 border-amber-300";

const Badge = ({ label, value, done, testId }) => {
  const Icon = done ? Check : Minus;
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border text-[11px] font-medium whitespace-nowrap ${done ? DONE : PENDING}`}
      data-testid={testId}>
      <Icon size={11} strokeWidth={2.5} aria-hidden="true" />
      {label}: {value}
    </span>
  );
};

export default function DokumenBadges({ patient }) {
  const espr = patient.espr || "Tidak Ada";
  const eKmkb = patient.e_kmkb || "Belum";
  return (
    <div className="flex flex-col items-start gap-1">
      <Badge label="E-SPR" value={espr} done={espr === "Ada"} testId={`espr-${patient.no_rm}`} />
      <Badge label="E-KMKB" value={eKmkb} done={eKmkb === "Sudah"} testId={`e-kmkb-${patient.no_rm}`} />
    </div>
  );
}
